export function padNumber(num: number, targetLength: number): string {
    return num.toString().padStart(targetLength, '0');
}